import { render, staticRenderFns } from "./TasksHistoryDialog.vue?vue&type=template&id=b89d56cc&scoped=true"
import script from "./TasksHistoryDialog.vue?vue&type=script&lang=js"
export * from "./TasksHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./TasksHistoryDialog.vue?vue&type=style&index=0&id=b89d56cc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89d56cc",
  null
  
)

export default component.exports